import { useSlots as _useSlots, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from "vue";
import { useDefaults } from "vuetify";
import { mathFix } from "@/services/mathServices";

import { TextFieldProps } from ".";

type OssTextFieldProps = {
    modelValue: number | string | null;
    trueInput?: boolean;
} & TextFieldProps;


export default /*@__PURE__*/_defineComponent({
  __name: 'OssTextField',
  props: {
    modelValue: {},
    trueInput: { type: Boolean },
    flat: { type: Boolean },
    reverse: { type: Boolean },
    variant: {},
    error: { type: Boolean },
    bgColor: {},
    label: {},
    active: { type: Boolean },
    direction: {},
    style: {},
    autofocus: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: [Boolean, null] },
    messages: {},
    focused: { type: Boolean },
    errorMessages: {},
    maxErrors: {},
    rules: {},
    tile: { type: Boolean },
    density: {},
    clearIcon: {},
    hideSpinButtons: { type: Boolean },
    persistentHint: { type: Boolean },
    clearable: { type: Boolean },
    dirty: { type: Boolean },
    persistentClear: { type: Boolean },
    singleLine: { type: Boolean },
    hideDetails: { type: [Boolean, String] },
    rounded: {}
  },
  emits: ["update:modelValue", "tab", "change"],
  setup(__props: any, { emit: __emit }) {

const _props = __props;

const slots = _useSlots();

const filterProps = (props: Record<string, any>) => {
    const result = { ...props };
    delete result["onUpdate:modelValue"];
    delete result["modelValue"];
    return result;
};

//Cannot use useDefault hors script.setup . Even if this is inside the setup function, when loaded by other components, it is not inside the setup function of the component using it.
//const props = computed<TextFieldProps>(() => useDefaults(filterProps(_props)));
const props = computed<TextFieldProps>(() => filterProps(_props));
const emit = __emit;

// Formatteur pour afficher les nombres avec des espaces et une virgule comme séparateur de décimales

const _internalValue = ref<string | null>(null);

const internalValue = computed<string>({
    get: () => {
        // debugger;
        if (_internalValue.value) {
            return _internalValue.value;
        }
        if (_props.modelValue === null || _props.modelValue === undefined) {
            return "";
        }
        const value = _props.modelValue.toString();
        return value;
    },

    set: (value: string) => {
        // debugger;
        if (!value) {
            _internalValue.value = value;
            if (_props.trueInput) {
                emit("update:modelValue", "");
            } else {
                emit("update:modelValue", 0);
            }
        } else {
            // debugger;
            const cleanedValue = value.replace(/[<>{}&$\^[\]]/g, "");
            _internalValue.value = cleanedValue.replace(/[^0-9\\+,\\.\\*\\/\\(\\)-]/g, "");
            const valueS = _internalValue.value.replace(/,/g, ".");
            // debugger
            // _internalValue.value = value;
            // const valueS = value;

            const _value = parseFloat(valueS);
            if (!isNaN(_value) && !containsOperator(_internalValue.value)) {
                emit("update:modelValue", _value);
            }
            // else {
            //     _internalValue.value = value;
            // }
        }
    },
});

const keyDown = ($event) => {
    if ($event.key === "Tab") {
        emit("tab", $event);
        return;
    }
};

// const keyUp = ($event) => {
// let keyCode = $event.keyCode ? $event.keyCode : $event.which;
// if (keyCode === 46 || keyCode === 44) {
//     if (internalValue.value.includes(",")) {
//         if (
//             internalValue.value.includes("+") ||
//             internalValue.value.includes("-") ||
//             internalValue.value.includes("*") ||
//             internalValue.value.includes("/")
//         ) {
//             keyCode = 46;
//         } else {
//             $event.preventDefault();
//         }
//     } else {
//         keyCode = 46;
//     }
//     return;
// }
// if (
//     (keyCode < 48 || keyCode > 57) && // 0 to 9
//     keyCode !== 44 && // ,
//     keyCode !== 46 && // .
//     keyCode !== 45 && // -
//     keyCode !== 43 && // +
//     keyCode !== 42 && // *
//     keyCode !== 47 && // /
//     keyCode !== 40 && // (
//     keyCode !== 41 // )
// ) {
//     $event.preventDefault();
//     return;
// }
// };

function containsOperator(string) {
    return (
        string.includes("-") ||
        string.includes("+") ||
        string.includes("*") ||
        string.includes("/") ||
        string.includes("(") ||
        string.includes(")")
    );
}

const change = () => {
    if (_internalValue.value) {
        const string = _internalValue.value as string;
        const lString = string.replace(/,/g, ".");
        if (containsOperator(string)) {
            try {
                console.log(lString);
                const result = new Function("return " + lString)();
                console.log(result);
                if (result !== null && result !== undefined) {
                    emit("update:modelValue", parseFloat(mathFix(result).toString()));
                    _internalValue.value = null;
                }
            } catch (e) {
                console.error(e);
            }
        } else {
            const _value = parseFloat(lString);
            if (!isNaN(_value)) {
                emit("update:modelValue", _value);
                _internalValue.value = null;
            }
        }
    }

    emit("change");
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(_component_v_text_field, _mergeProps({
    modelValue: internalValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event))
  }, props.value, {
    onKeydown: keyDown,
    onChange: change
  }), _createSlots({ _: 2 }, [
    (!!slots.label)
      ? {
          name: "label",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "label")
          ]),
          key: "0"
        }
      : undefined
  ]), 1040, ["modelValue"]))
}
}

})